var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(0 -0.082)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0.082)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.162 6.556)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M293.847,10.794a5.142,5.142,0,0,0,3.775-1.578,5.236,5.236,0,0,0,1.561-3.8,5.237,5.237,0,0,0-1.561-3.8,5.3,5.3,0,0,0-7.55,0,5.236,5.236,0,0,0-1.561,3.8,5.236,5.236,0,0,0,1.561,3.809A5.143,5.143,0,0,0,293.847,10.794Zm0,0",
    transform: "translate(-284.745 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M18.446,826.268a13.423,13.423,0,0,0-.179-1.413,11.221,11.221,0,0,0-.344-1.421,7.052,7.052,0,0,0-.578-1.326,5,5,0,0,0-.873-1.148,3.845,3.845,0,0,0-1.254-.795,4.3,4.3,0,0,0-1.6-.293,1.618,1.618,0,0,0-.868.372c-.26.171-.565.369-.9.585a5.159,5.159,0,0,1-1.17.52,4.5,4.5,0,0,1-2.861,0,5.149,5.149,0,0,1-1.17-.52c-.337-.217-.641-.415-.905-.585a1.614,1.614,0,0,0-.861-.371,4.292,4.292,0,0,0-1.6.293,3.841,3.841,0,0,0-1.254.795,5,5,0,0,0-.873,1.148,7.061,7.061,0,0,0-.578,1.326,11.245,11.245,0,0,0-.344,1.421,13.372,13.372,0,0,0-.179,1.413C.016,826.7,0,827.141,0,827.59a3.732,3.732,0,0,0,1.093,2.81,3.914,3.914,0,0,0,2.817,1.037H14.58A3.913,3.913,0,0,0,17.4,830.4a3.73,3.73,0,0,0,1.093-2.81C18.491,827.139,18.475,826.694,18.446,826.268Zm0,0",
    transform: "translate(0.003 -809.079)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f40cfae90438330e7ec45ca415664ca5.svg";
export { ForwardRef as ReactComponent };